import { render, staticRenderFns } from "./layoutCenter.vue?vue&type=template&id=a2da92be&scoped=true&"
import script from "./layoutCenter.vue?vue&type=script&lang=js&"
export * from "./layoutCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2da92be",
  null
  
)

export default component.exports